import styled from 'styled-components';
import { useState } from 'react';
import { hapticsImpactLight } from '../../../common/haptic';

const Container = styled.div`
  width: 100%;
`;

const InputContainer = styled.div`
  background-color: ${({ theme }) => theme.background.light};
  border: 1px solid transparent;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  gap: 15px;

  ${({ $isFocused, $hasError, theme }) => {
    if ($hasError) {
      return `border-color: ${theme.text.error};`;
    }
    if ($isFocused) {
      return `border-color: ${theme.primary.primary};`;
    }
    return '';
  }}
`;

const StyledInput = styled.input`
  border: unset;
  height: 100%;
  background-color: ${({ theme }) => theme.background.light};
  color: ${({ theme }) => theme.text.regular};
  border-radius: 16px;
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: normal;
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.text.secondary};
`;

const MaxButton = styled.button`
  color: ${({ theme }) => theme.text.regular};
  background: none;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.text.regular};
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.text.error};
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Inter', sans-serif;
`;

const AmountInput = ({
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  onMaxClick,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <InputContainer $isFocused={isFocused} $hasError={!!error}>
        <StyledInput
          type='number'
          inputMode='decimal'
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...props}
        />
        {onMaxClick && (
          <MaxButton
            type='button'
            onClick={() => {
              hapticsImpactLight();
              onMaxClick();
            }}
          >
            Max
          </MaxButton>
        )}
      </InputContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default AmountInput;
